import { Component, OnInit } from '@angular/core';
import { Editor, toHTML } from 'ngx-editor';
import { MmpiaService } from 'src/app/services/mmpia.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-mmpia-interpretations',
  templateUrl: './mmpia-interpretations.component.html',
  styleUrls: ['./mmpia-interpretations.component.css']
})
export class MmpiaInterpretationsComponent implements OnInit {

  public interpretations = [];
  public scales = [];
  public allScales = [];
  public scale = {
    scale:"",
    ranks:[]
  }
  public lastScale = "";
  public rank = {
    name:"",
    min:0,
    max:0,
    text:"",
    textF:"",
  }

  public loadingScales = false;

  public isEditingScale = false;
  public isEditingRank = false;

  public editor:Editor;
  public html;
  public editor2:Editor;
  public html2;
  constructor(
    private mmpiaService:MmpiaService
  ) { }

  ngOnInit(): void {
    this.editor = new Editor();
    this.editor2 = new Editor();
    this.loadingScales = true;
    this.mmpiaService.getScales().subscribe(
      resp=>{
        this.loadingScales = false;
        this.allScales = resp.all;
        let scalesArray = [];
        this.allScales.map(
          scale=>{
            if(scale.type=='basicas') {
              if (scale.scale=='L'||scale.scale=='?'||scale.scale=='F'||scale.scale=='F1'||scale.scale=='F2'||scale.scale=='K'||scale.scale=='FB'||scale.scale=='VRIN'||scale.scale=='TRIN') scalesArray.push(scale)
            }             }
        )
        this.scales = scalesArray;
      },
      err=>console.log(err)
    )
    this.mmpiaService.getInterpretations().subscribe(
      resp=>{
        this.interpretations = resp;
      },
      err=>console.log(err)
    )
  }

  handleDelete(i){
    this.interpretations.splice(i,1);
  }

  changeType(e){
    let scalesArray = [];
    this.allScales.map(
      scale=>{
        if(e=='validez'&&scale.type=='basicas') {
          if (scale.scale=='L'||scale.scale=='?'||scale.scale=='F'||scale.scale=='F1'||scale.scale=='F2'||scale.scale=='K'||scale.scale=='FB'||scale.scale=='VRIN'||scale.scale=='TRIN') scalesArray.push(scale)
        }
        if(e=='clinicas'&&(scale.type=='basicas')) {
          if (scale.scale!='L'&&scale.scale!='?'&&scale.scale!='F'&&scale.scale!='F1'&&scale.scale!='F2'&&scale.scale!='K'&&scale.scale!='FB'&&scale.scale!='F(P)'&&scale.scale!='VRIN'&&scale.scale!='TRIN') scalesArray.push(scale)
        }
        if(e=='lingoes'&&(scale.type=='lingoes')) {
          scalesArray.push(scale)
        }
        if(e=='contenido'&&scale.type=='contenido') scalesArray.push(scale)
        if(e=='suplementarias'&&scale.type=='suplementarias') scalesArray.push(scale)
      }
    )
    this.scales = scalesArray;
  }

  changeScale(s){
    if (this.lastScale.length>0){
      Swal.fire({
        icon:'info',
        title:'¿Cambiar escala?',
        text:'Debe actualizar la escala seleccionada para que se guarden los datos',
        showCancelButton:true,
        confirmButtonText:'Cambiar',
        cancelButtonText:'Cancelar'
      }).then(
        resp=>{
          if(resp.isConfirmed){
            this.html="";
            this.lastScale = s;
            let founded = false;
            for (let i of this.interpretations){
              if (s === i.scale) {
                this.scale.scale = s;
                this.scale.ranks = i.ranks;
                founded = true;
              }
            }
            if (!founded){
              this.scale = {
                scale:s,
                ranks:[]
              }
            }
            this.rank = {
              name:"",
              min:0,
              max:0,
              text:"",
              textF:"",
            }
          }else{
            this.scale.scale = this.lastScale;
          }
        }
      )
    }else{
      this.lastScale = s;
      let founded = false;
      for (let i of this.interpretations){
        if (s === i.scale) {
          this.scale.scale = s;
          this.scale.ranks = i.ranks;
          founded = true;
        }
      }
      if (!founded){
        this.scale = {
          scale:s,
          ranks:[]
        }
      }
      this.rank = {
        name:"",
        min:0,
        max:0,
        text:"",
        textF:"",
      }
    }
  }

  addRank(){
    let i = 0;
    let founded = false;
    for (let r of this.scale.ranks){
      if (this.rank.name == r.name){
        founded = true;
      }else if(!founded) i++;
    }
    var html;
    if (this.html.type == "doc"){
      html = toHTML(this.html);
    }else{
      html = this.html;
    }
    this.rank.text = html;
    if (this.scale.scale=='Mf'){
      var html2;
      if (this.html2.type == "doc"){
        html2 = toHTML(this.html2);
      }else{
        html2 = this.html2;
      }
      this.rank.textF = html2;
    }
    if (!founded) this.scale.ranks.push(this.rank);
    else this.scale.ranks[i] = this.rank;
    this.html="";
    this.html2="";
    this.rank = {
      name:"",
      min:0,
      max:0,
      text:"",
      textF:"",
    }
  }

  editRank(r, index){
    this.rank = r;
    this.html = r.text;
    if(this.scale.scale=='Mf') this.html2 = r.textF; 
    this.isEditingRank = true;
  }

  deleteRank(i){
    this.scale.ranks.splice(i,1);
  }


  update(){
    if(this.scale.scale){
      let founded = false;
      let i = 0;
      for (let interpretation of this.interpretations){
        if (interpretation.scale == this.scale.scale){
          founded = true;
        }else if (!founded) i++;
      }
      if (!founded) {
        this.interpretations.push(this.scale)
      }
      else this.interpretations[i] = this.scale;
      this.mmpiaService.updateScale(this.scale).subscribe(
        resp=>{
          Swal.fire("Escala actualizada").then(
            resp=>{
              this.editor.destroy();
              this.editor = new Editor();
              this.html="";
              this.editor2.destroy();
              this.editor2 = new Editor();
              this.html2="";
            }
          );
        },
        err=>console.log(err)
      )
      this.scale = {
        scale:"",
        ranks:[]
      }
      this.lastScale = '';
    }
  }

}
